import {MI} from "../init";
import {behavior_config, he, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {ReelMotion} from "./ReelMotion";
import {SpinReel} from "./SpinReel";
import {copyArray} from "../../framework/src/helpers";
import {ReelsEngine} from "./ReelsEngine";

/**
 * @constructor
 * @returns {SpinReels}
 */
export function SpinReels() {

	/** @type {GameConfig}  */
	this._gameConfig;

	/** @type {ServerCfg} */
	this._serverConfig;

	/** @type {Array} */
	this._serverReels;

	/** @type {SymbolsManager} */
	this.symbolsManager;

	/** @type Array<SpinReel> */
	this.reels = [];

	/** @type {ReelPrinter} */
	this._printer;

	/** @type {MadnesGraphics} */
	this.blackScreen;

	/** @type {number} */
	this.blackScreenAlpha = 0.50;

	/** @type {MadnesGroup} */
	this.symbolsGroup;
	/** @type {MadnesGroup} */
	this.animsSymbolsGroup;

	/** @type {MadnesGroup} */
	this.arrowsSymbolsGroup;

	/** @type {Array<AbstractSymbol>} */
	this.stickSymbols = [];

	/** @type {ReelsEngine} */
	this._engine;

	this._symbolsScale = 1;
};

SpinReels.prototype.setSymbolsScale = function(scale) {
	this._symbolsScale = scale;
};

/**
 * @param {ReelPrinter} reelPrinter
 * @param {GameConfig} gameConfig
 * @param {ServerCfg} serverConfig
 * @param {SymbolsManager} symbolsManager
 * @returns {undefined}
 */
SpinReels.prototype.init = function(reelPrinter, gameConfig, serverConfig, symbolsManager) {
	this._printer = reelPrinter;
	this._gameConfig = gameConfig;
	this._serverConfig = serverConfig;
	// override with Settings.behavior
	this._serverConfig._serverConfig.behavior = behavior_config;
	this._symbolsManager = symbolsManager;
};

/** @param {MadnesGroup} symbolsGroup */
SpinReels.prototype.setSymbolsGroup = function(symbolsGroup) {
	this.symbolsGroup = symbolsGroup;
};

/** @param {Array} sReels */
SpinReels.prototype.setServerReels = function(sReels) {
	this._serverReels = sReels;
};

SpinReels.prototype.getServerReels = function() {
	return this._serverReels;
};

SpinReels.prototype.createReels = function() {

	var serverMatrix = this._serverConfig.getReelMatrix();
	var failMatrix = this._serverConfig.getFailResult();

	var serverPositions = this._serverConfig.getPositions();

	for(var i = 0; i < this._serverReels.length; i++) {

		var motion = new ReelMotion();
		var reel = new SpinReel();

		reel.setScale(this._symbolsScale);
		reel.init(i, this._gameConfig, this._symbolsManager, this._printer, motion);

		this.reels[i] = reel;
		this.reels[i].setAllMatrix(copyArray(this._serverReels[i]));
		this.reels[i].setReelMatrix(copyArray(serverMatrix[i]));
		this.reels[i].setFailMatrix(failMatrix[i]);
		this.reels[i].setSymbolPosition(serverPositions[i]);

		this.reels[i].create(this.symbolsGroup);

		motion.init(this._gameConfig, this._serverConfig, this.reels[i], this._printer);
	}

	this._engine = new ReelsEngine();
	this._engine.onLoop(function(delta) {

		for(var i = 0; i < 5; i++) {
			this.reels[i].motion.tick(delta);
		}

	}.bind(this));

	this.printReels();
};

SpinReels.prototype.visibleResSymbols = function(bool) {
	for(var i = 0; i < this.reels.length; i++) {
		this.reels[i].visibleResSymbols(bool);
	}
};

SpinReels.prototype.reinitReelsSymbols = function() {
	for(var i = 0; i < this.reels.length; i++) {
		this.reels[i].initResSymbols(this.symbolsGroup);
		this.reels[i].createResSymbols();
		this.reels[i].initSymbols();
	}
};

SpinReels.prototype.startSpinReels = function () {
	this._engine.start();
};

SpinReels.prototype.stopSpinReels = function () {
	this._engine.stop();
};

SpinReels.prototype.createBlackScreen = function() {
	this.blackScreen = MI.addGraphics(0, 0, "black_screen");
	this.blackScreen.beginFill(0x000000);
	this.blackScreen.drawRectangle(30, 0, wi - 30, he - 70);
	this.blackScreen.setAlpha(0);
	this.blackScreen.setVisible(false);
};

/**
 * @param {number=} dur
 * @returns {Promise}
 */
SpinReels.prototype.fadeInBlackScreen = function(dur) {

	if(typeof dur === 'undefined') { dur = 300; }

	return new Promise(function(res) {

		if(this.blackScreen.getAlpha() === this.blackScreenAlpha) {
			res();
			return;
		}

		this.blackScreen.setAlpha(0);
		this.blackScreen.setVisible(true);

		MI.addTween().to(this.blackScreen, { 'alpha': this.blackScreenAlpha }, {
			'duration': dur,
			'callback': res
		});
	}.bind(this));
};

/**
 * @param {number=} dur
 * @returns {Promise}
 */
SpinReels.prototype.fadeOutBlackScreen = function(dur) {

	if(typeof dur === 'undefined') { dur = 300; }

	return new Promise(function(res) {

		if(this.blackScreen.getAlpha() === 0) {
			res();
			return;
		}

		//this.blackScreen.setAlpha(1);
		MI.addTween().to(this.blackScreen, { 'alpha': 0 }, {
			'duration': dur,
			'callback': function() {
				this.blackScreen.setVisible(false);
				res();
			}.bind(this)
		});
	}.bind(this));
};

SpinReels.prototype.initSymbols = function() {
	for(var i = 0; i < this.reels.length; i++) {
		this.reels[i].initSymbols();
	}

};

/**
 * @param {Array} reelMatrix
 * @returns {undefined}
 */
SpinReels.prototype.prepareResult = function(reelMatrix) {
	this.setResult(reelMatrix);
	this.makeResSymbols();
	this.setMotionResult();
};

/**
 * @param {Array} reelMatrix
 * @param {boolean=} force
 * @returns {undefined}
 */
SpinReels.prototype.setResult = function(reelMatrix, force) {

	for(var i = 0; i < this.reels.length; i++) {
		if(!force && !this.reels[i].started) {
			console.warn("reel " + this.reels[i].id + " not spinning - cannot set result matrix");
			continue;
		}

		this.reels[i].setReelMatrix(reelMatrix[i]);
		this.reels[i].initResSymbols(this.symbolsGroup);
	}
};

SpinReels.prototype.setMotionResult = function() {

	for(var i = 0; i < this.reels.length; i++) {
		if(!this.reels[i].started) {
			console.warn("reel " + this.reels[i].id + " not spinning - cannot set result");
			continue;
		}

		this.reels[i].motion.setResultSymbols(this.reels[i].resSymbols);
	}
};

SpinReels.prototype.makeResSymbols = function() {
	for(var i = 0; i < this.reels.length; i++) {

		if(!this.reels[i].started) {
			console.warn("reel " + this.reels[i].id + " not spinning - cannot set blur symbol");
			continue;
		}

		this.reels[i].createBlurSymbols(this.reels[i].resSymbols, this.symbolsGroup);
	}
};

SpinReels.prototype.printReels = function() {
	for(var i = 0; i < this.reels.length; i++) {
		this._printer.print(this.reels[i]);
	}
};

/**
 * @public
 * @returns {Array<SpinReel>}
 */
SpinReels.prototype.getReels = function() {
	return this.reels;
};

/**
 * @param {number} id
 * @returns {SpinReel}
 */
SpinReels.prototype.getReel = function(id) {
	return this.reels[id];
};

SpinReels.prototype.getResSymbol = function(x, y) {
	return this.getReel(x).resSymbols[y];
};

/**
 * @param {Array} positions
 * @returns {Array<AbstractSymbol>}
 */
SpinReels.prototype.getResSymbols = function(positions) {
	var symbols = [];

	for(var i = 0; i < positions.length; i++) {
		var x = positions[i][0];
		var y = positions[i][1];

		symbols.push(this.getResSymbol(x, y));
	}

	return symbols;
};

/**
 * @returns {Array<AbstractSymbol>}
 */
SpinReels.prototype.getAllresSymbols = function() {
	var symbols = [];

	for(var i = 0; i < this.reels.length; i++) {

		for(var j = 0; j < this.reels[i].resSymbols.length; j++) {
			symbols.push(this.reels[i].resSymbols[j]);
		}
	}

	return symbols;
};

/**
 * @returns {Array<AbstractSymbol>}
 */
SpinReels.prototype.getAllSpreadedSymbols = function() {

	var symbols = this.getAllresSymbols();
	var symbs = [];

	for(var i = 0; i < symbols.length; i++) {
		if(symbols[i].spreaded) {
			symbs.push(symbols[i]);
		}
	}

	return symbs;
};

/**
 * @param {number} id
 * @returns {AbstractSymbol|null}
 */
SpinReels.prototype.getSpreadedFromReel = function(id) {

	var symbols = this.getReel(id).resSymbols;

	for(var i = 0; i < symbols.length; i++) {
		if(symbols[i].spreaded) {
			return symbols[i];
		}
	}

	return null;
};

/**
 *
 * @param {Array<AbstractSymbol>} spreadSymbols
 */
SpinReels.prototype.setSpreaded = function(spreadSymbols) {
	for(var i = 0; i < spreadSymbols.length; i++) {
		var reelX = spreadSymbols[i].reelPos['x'];
		this.getReel(reelX).spreaded = true;
	}
};

/**
 * @param {AbstractSymbol} symbol
 * @param {number=} reelX
 * @param {number=} reelY
 * @returns {undefined}
 */
SpinReels.prototype.addSymbol = function(symbol, reelX, reelY) {

	reelX = typeof reelX === 'undefined' ? symbol.getReelX() : reelX;
	reelY = typeof reelY === 'undefined' ? symbol.getReelY() : reelY;

	this.getReel(reelX).resSymbols[reelY] = symbol;
};

/**
 * @param {AbstractSymbol} symbol
 * @returns {boolean}
 */
SpinReels.prototype.isInSpread = function(symbol) {
	var reelX = symbol.getReelX();
	return this.getReel(reelX).spreaded;

};

SpinReels.prototype.reinitSpreaded = function() {
	for(var i = 0; i < this.reels.length; i++) {
		this.getReel(i).spreaded = false;
	}
};

SpinReels.prototype.killAllSymbols = function() {
	for(var i = 0; i < this.reels.length; i++) {
		this.getReel(i).killAllSymbols();
	}
};

SpinReels.prototype.hideInvisibleSymbols = function() {
	for(var i = 0; i < this.reels.length; i++) {
		this.getReel(i).hideInvisibleSymbols();
	}
};

SpinReels.prototype.reviveAllSymbols = function() {
	for(var i = 0; i < this.reels.length; i++) {
		this.getReel(i).reviveAllSymbols();
	}
};

SpinReels.prototype.destroy = function() {

	this._engine && this._engine.destroy();
	this._engine = null;

	this.blackScreen && this.blackScreen.destroy();

	//this.symbolsGroup && this.symbolsGroup.destroy();
	this.animsSymbolsGroup && this.animsSymbolsGroup.destroy();
	this.arrowsSymbolsGroup && this.arrowsSymbolsGroup.destroy();

	for(var i = 0; i < this.stickSymbols.length; i++) {
		this.stickSymbols[i].destroy();
	}
	this.stickSymbols.length = 0;

	this._printer = null;

	for(var i = 0; i < this.reels.length; i++) {
		this.reels[i].destroy();
	}
	this.reels.length = 0;
};